import { render, staticRenderFns } from "./Registration.vue?vue&type=template&id=6c02e6a5"
import script from "./Registration.vue?vue&type=script&lang=js"
export * from "./Registration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports